import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserSupportComponent } from './user-support.component';

const routes: Routes = [
  {
    path: '',
    component: UserSupportComponent
  },
  {
    path: 'jitsi',
    component: UserSupportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserSupportRoutingModule {}
